import type { SessionService } from '@/application/session/SessionService'
import type { AccountRepository } from '@/domain/account/AccountRepository'
import type { LoginParams } from '@/domain/auth/Auth'
import type { AuthRepository } from '@/domain/auth/AuthRepository'
import type { AuthService, LoginResult } from './AuthService'

/**
 * 认证服务的默认实现
 */
export class DefaultAuthService implements AuthService {
  constructor(
    private readonly authRepository: AuthRepository,
    private readonly accountRepository: AccountRepository,
    private readonly sessionService: SessionService,
  ) {}

  async login(params: LoginParams): Promise<LoginResult> {
    const trimmedAgentName = params.agentName.trim()
    if (!trimmedAgentName || !params.password) {
      throw new Error('Please enter username and password')
    }

    const loginResult = await this.authRepository.login({
      agentName: trimmedAgentName,
      password: params.password,
    })

    this.sessionService.setAccessToken(loginResult.access_token)
    this.sessionService.setAgentId(loginResult.agent_id)
    this.sessionService.setExpiresAt(
      Date.now() + loginResult.duration_seconds * 1000,
    )

    try {
      const profile = await this.accountRepository.getProfile(
        loginResult.agent_id,
      )
      const hasNickname = Boolean(profile.nickname)

      return {
        accessToken: loginResult.access_token,
        agentId: loginResult.agent_id,
        hasNickname,
      }
    } catch (error) {
      this.sessionService.clearSession()
      throw error
    }
  }

  logout(): void {
    this.sessionService.clearSession()
  }
}
